<div class="min-h-screen flex flex-col bg-white">
  <!-- Dynamic Header -->
  @if (showHeaderFooter) {
    <app-header></app-header>
  }

  <!-- Main Content Shell -->
  <main 
    id="main-content"
    class="flex-1 flex flex-col relative z-0" 
     
  >
    <app-loader></app-loader>
    <div class="flex-1 animate-page-reveal" [class.pt-36]="router.url.startsWith('/digitalLibrary') || router.url.startsWith('/training')">
      <router-outlet></router-outlet>
      
    </div>
  </main>

  <!-- Dynamic Footer -->
  @if (showHeaderFooter) {
    
      <app-footer ></app-footer>
   
  }

 
</div>
